var _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "header-illustration",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1252.286,
    height: 754.66,
    viewBox: "0 0 1180.286 754.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    style: {
      fill: "none"
    },
    d: "M0 0h1252.286v754.66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    style: {
      fill: "none"
    },
    d: "M0 0h1252.283v754.657H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "m812.2 778.177 229.241 79.15 293.116-103.365-229.241-79.15z",
    transform: "translate(-812.199 -674.812)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "m812.2 639.172 229.241 79.149 293.116-103.365-229.241-79.15z",
    transform: "translate(-812.199 -535.807)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "m812.2 502.175 229.241 79.149 293.116-103.365-229.242-79.149z",
    transform: "translate(-812.199 -398.81)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "m812.2 363.173 229.241 79.149 293.112-103.363-229.239-79.149z",
    transform: "translate(-812.202 -259.81)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    style: {
      fill: "none"
    },
    d: "M0 0h35.342v12.271H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "m1088.881 114.168 44.757 16.991 3.274-67.054-44.757-16.99z",
    transform: "translate(-1088.881 -47.115)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    style: {
      fill: "#00a2d2"
    },
    d: "M0 0h105.829v139.477H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "m1385.535 200.366 36.647 10.853.36-9.713-36.649-10.854z",
    transform: "translate(-1385.535 -190.653)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "m1211.036 278.09 17.006 5.036.292-7.867-17.007-5.037z",
    transform: "translate(-1211.036 -270.222)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "m1238 242.132 41.007 12.145.272-7.359-41.007-12.145z",
    transform: "translate(-1237.998 -234.773)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "m1104.8 300.559 35.552 10.529.359-9.713-35.552-10.528z",
    transform: "translate(-1104.797 -290.846)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "m558.347 427.911.14 9.71 39.125-14.364-.14-9.709z",
    transform: "translate(-558.347 -413.547)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "m382.711 451.391.138 9.581 54.376-19.962-.138-9.581z",
    transform: "translate(-382.711 -431.429)",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "m710.476 586.378-274.183 96.688a85.363 85.363 0 0 1-56.247.185L323.281 664.6a42.491 42.491 0 0 0-28 .092l-181.054 63.85L6.663 766.473a9.982 9.982 0 0 0 .062 18.849l386.084 132.354a27.953 27.953 0 0 0 18.42-.061L543.7 870.9a81.669 81.669 0 0 1 53.815-.176l43.977 15.184 155.585 53.718a37.023 37.023 0 0 0 24.4-.08l424.151-149.573a9.982 9.982 0 0 0-.062-18.849z",
    transform: "translate(0 -186.999)",
    style: {
      fill: "#aec0ca"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(553.19 459.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726",
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "m1256.537 727.037-133.575-46.119c-7.519-2.6-20.77-2.18-29.6.934l-157.475 55.532-103.678 36.561c-8.824 3.112-9.883 7.741-2.363 10.338L977.038 835.1l54.808 18.924c7.523 2.6 20.779 2.179 29.6-.932l125.327-44.2c8.824-3.111 9.883-7.741 2.359-10.339l-41.19-14.222c-7.523-2.6-6.466-7.224 2.364-10.337l103.865-36.627c8.829-3.114 9.883-7.741 2.363-10.338",
    transform: "translate(-816.227 -676.216)",
    style: {
      fill: "#a1c7d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    transform: "translate(553.19 364.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "m1256.536 588.032-133.575-46.119c-7.519-2.6-20.775-2.177-29.6.934l-157.48 55.534-103.673 36.559c-8.829 3.114-9.883 7.741-2.363 10.338L977.037 696.1l54.808 18.924c7.523 2.6 20.774 2.181 29.6-.932l125.326-44.192c8.829-3.113 9.883-7.741 2.359-10.339l-41.19-14.221c-7.524-2.6-6.461-7.226 2.363-10.338l103.869-36.628c8.824-3.112 9.883-7.741 2.363-10.338",
    transform: "translate(-816.227 -537.211)",
    style: {
      fill: "#00a2d1"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "m1255.6 651.025 107.946-37.414-32.482-11.4-107.578 37.279z",
    transform: "translate(-390.168 -192.049)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M1254.619 629.454a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-399.171 -198.883)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "m1258.454 632.552-7.064 2.119a1.365 1.365 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.053 5.446-1.912 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-398.757 -201.705)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "m1253.936 643.158-3.3 1.131-.187-6.761 1.6.095z",
    transform: "translate(-398.767 -203.31)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "m1264.062 636.206 15.455-5.089.058 10.492-15.455 5.091z",
    transform: "translate(-403.108 -201.266)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M1299.724 613.958a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-413.554 -193.942)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "m1303.559 617.056-7.064 2.119a1.365 1.365 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.053 5.446-1.913 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-413.141 -196.763)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "m1299.041 627.662-3.3 1.131-.188-6.761 1.6.095z",
    transform: "translate(-413.151 -198.369)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "m1309.167 620.71 15.455-5.089.058 10.492-15.455 5.089z",
    transform: "translate(-417.492 -196.324)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M1344.138 598.738a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-427.718 -189.088)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "m1347.973 601.836-7.064 2.119a1.364 1.364 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.052 5.446-1.913 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-427.304 -191.91)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "m1343.454 612.443-3.3 1.131-.188-6.761 1.6.095z",
    transform: "translate(-427.314 -193.515)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "m1353.581 605.49 15.455-5.089.058 10.492-15.455 5.089z",
    transform: "translate(-431.655 -191.471)",
    style: {
      fill: "#00939e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733",
    transform: "translate(527.211 286.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "m1256.537 451.034-133.575-46.119c-7.519-2.6-20.775-2.177-29.6.934l-157.48 55.534-103.673 36.559c-8.824 3.112-9.883 7.741-2.363 10.338l147.192 50.82 54.808 18.924c7.523 2.6 20.779 2.179 29.6-.932l125.327-44.2c8.824-3.111 9.883-7.741 2.359-10.338l-41.19-14.222c-7.523-2.6-6.466-7.224 2.364-10.337l103.865-36.627c8.824-3.112 9.883-7.741 2.363-10.338",
    transform: "translate(-816.227 -400.214)",
    style: {
      fill: "#a1c7d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M1184.525 575.214 1076.579 537.8l32.482-11.4 107.578 37.279z",
    transform: "translate(-343.32 -167.872)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M1248.363 553.643a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-397.175 -174.707)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "m1241.237 556.741 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.052-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-394.298 -177.529)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "m1250.133 567.347 3.3 1.131.188-6.761-1.6.095z",
    transform: "translate(-398.666 -179.134)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "m1234.376 560.395-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-388.694 -177.09)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M1203.257 538.146a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-382.791 -169.765)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "m1196.132 541.244 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-379.914 -172.587)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "m1205.028 551.851 3.3 1.131.187-6.761-1.6.095z",
    transform: "translate(-384.282 -174.192)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "m1189.271 544.9-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-374.31 -172.148)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M1158.844 522.926a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-368.628 -164.912)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "m1151.718 526.025 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-365.75 -167.734)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "m1160.615 536.631 3.3 1.131.185-6.762-1.6.095z",
    transform: "translate(-370.119 -169.339)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "m1144.858 529.679-15.458-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-360.147 -167.295)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M1108.525 605.214 1000.579 567.8l32.482-11.4 107.578 37.279z",
    transform: "translate(-319.084 -177.439)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M1172.363 583.643a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-372.939 -184.274)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "m1165.237 586.741 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-370.061 -187.096)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "m1174.133 597.347 3.3 1.131.188-6.761-1.6.095z",
    transform: "translate(-374.43 -188.701)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "m1158.376 590.395-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-364.458 -186.657)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M1127.257 568.146a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-358.555 -179.332)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "m1120.132 571.244 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-355.678 -182.154)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "m1129.028 581.851 3.3 1.131.187-6.761-1.6.095z",
    transform: "translate(-360.046 -183.759)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "m1113.271 574.9-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-350.074 -181.715)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M1082.844 552.926a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-344.392 -174.479)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "m1075.718 556.025 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-341.514 -177.301)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "m1084.615 566.631 3.3 1.131.185-6.762-1.6.095z",
    transform: "translate(-345.883 -178.906)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "m1068.858 559.679-15.458-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-335.911 -176.862)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M1113.482 741.815 1005.536 704.4l32.482-11.4 107.582 37.282z",
    transform: "translate(-320.664 -221.001)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M1177.32 720.244a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-374.52 -227.836)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "m1170.194 723.342 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-371.642 -230.658)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "m1179.091 733.948 3.3 1.131.187-6.761-1.6.095z",
    transform: "translate(-376.011 -232.263)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "m1163.334 727-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-366.039 -230.219)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M1132.215 704.748a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-360.136 -222.895)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "m1125.089 707.846 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.052-5.446-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-357.258 -225.716)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "m1133.986 718.452 3.3 1.131.187-6.761-1.6.095z",
    transform: "translate(-361.627 -227.321)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "m1118.229 711.5-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-351.655 -225.277)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M1087.8 689.528a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-345.972 -218.041)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "m1080.675 692.626 7.064 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.447-1.913-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-343.095 -220.863)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "m1089.572 703.233 3.3 1.131.188-6.761-1.6.095z",
    transform: "translate(-347.463 -222.468)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "m1073.815 696.28-15.455-5.089-.058 10.492 15.455 5.089z",
    transform: "translate(-337.492 -220.424)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "m1255.6 512.025 107.946-37.414-32.482-11.4-107.578 37.279z",
    transform: "translate(-390.168 -147.722)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M1254.619 490.454a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-399.171 -154.556)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "m1258.454 493.552-7.064 2.119a1.365 1.365 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.053 5.446-1.913 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-398.757 -157.378)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "m1253.936 504.158-3.3 1.131-.187-6.761 1.6.095z",
    transform: "translate(-398.767 -158.983)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "m1264.062 497.206 15.455-5.088.058 10.492-15.455 5.09z",
    transform: "translate(-403.108 -156.939)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M1299.724 474.957a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-413.554 -149.615)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "m1303.559 478.056-7.064 2.119a1.365 1.365 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.053 5.446-1.913 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-413.141 -152.437)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "m1299.041 488.662-3.3 1.131-.188-6.761 1.6.095z",
    transform: "translate(-413.151 -154.042)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "m1309.167 481.71 15.455-5.089.058 10.492-15.455 5.089z",
    transform: "translate(-417.492 -151.997)",
    style: {
      fill: "#00939e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M1344.138 459.738a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.9",
    transform: "translate(-427.718 -144.761)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "m1347.973 462.836-7.064 2.119a1.364 1.364 0 0 0-.9 1.74l3.721 9.407 1.508-.471-1.037-4.052 5.446-1.913 1.9 3.892 1.225-.471-3.114-9.374a1.366 1.366 0 0 0-1.688-.876",
    transform: "translate(-427.304 -147.583)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "m1343.454 473.443-3.3 1.131-.188-6.761 1.6.095z",
    transform: "translate(-427.314 -149.188)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "m1353.581 466.49 15.455-5.089.058 10.492-15.455 5.089z",
    transform: "translate(-431.655 -147.144)",
    style: {
      fill: "#00939e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(553.192 176.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    style: {
      clipPath: "url(#clip-path-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "m1256.534 312.035-133.575-46.119c-7.519-2.6-20.77-2.18-29.6.934l-157.474 55.532-103.674 36.559c-8.829 3.113-9.883 7.741-2.363 10.338L977.04 420.1l54.808 18.924c7.523 2.6 20.774 2.181 29.6-.932l125.326-44.192c8.824-3.111 9.883-7.741 2.359-10.338l-41.19-14.222c-7.523-2.6-6.461-7.226 2.363-10.337l103.865-36.627c8.829-3.114 9.883-7.741 2.363-10.338",
    transform: "translate(-816.23 -261.214)",
    style: {
      fill: "#00a2d1"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M1203.069 832.637h-4.9a3 3 0 0 1-3-3v-5.578a3 3 0 0 1 3-3h4.9a3 3 0 0 1 3 3v5.578a3 3 0 0 1-3 3",
    transform: "translate(-381.139 -261.838)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M1201.731 816.8a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-382.305 -258.627)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M1137.576 846.973c0 8.79 20.522 15.915 45.837 15.915s45.837-7.125 45.837-15.915-20.522-15.915-45.837-15.915-45.837 7.125-45.837 15.915",
    transform: "translate(-362.772 -265.027)",
    style: {
      fill: "#e5e6ec"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(153.524 566.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2793",
    "data-name": "Group 2793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M232.146 837.087a2.514 2.514 0 1 0-2.514-2.514 2.514 2.514 0 0 0 2.514 2.514",
    transform: "translate(-226.753 -832.058)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M234.569 871.653V870.4l-.306-27.844a.65.65 0 0 0-.65-.65h-6.405a.651.651 0 0 0-.648.6l-1.151 14.2a.65.65 0 0 0 .648.7h.321a.65.65 0 0 0 .65-.65v-1.863l2.363 3.151a.651.651 0 0 1 .127.451l-2.072 12.74 3.352.838-1.515-1.515 1.934-8.123 1.721 9.937 3.307.12z",
    transform: "translate(-225.405 -835.197)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M1262.739 682.646a2.405 2.405 0 1 0-2.406-2.406 2.406 2.406 0 0 0 2.406 2.406",
    transform: "translate(-401.919 -216.164)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M1258.108 687.355h7.33a.892.892 0 0 1 .883.766l.644 4.509a.894.894 0 0 1-.141.621l-2.868 4.3a.893.893 0 0 0-.15.5v16.568h-3.076l-2.495-17.346a.892.892 0 0 0-.252-.5l-1.849-1.849a.891.891 0 0 1-.24-.824l1.342-6.039a.892.892 0 0 1 .871-.7",
    transform: "translate(-400.497 -219.2)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M1252.731 822.8a2.9 2.9 0 1 0-2.9-2.9 2.9 2.9 0 0 0 2.9 2.9",
    transform: "translate(-398.568 -260.541)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "m1245.605 825.9 7.063 2.119a1.365 1.365 0 0 1 .9 1.74l-3.721 9.407-1.508-.471 1.037-4.053-5.446-1.912-1.9 3.892-1.225-.471 3.114-9.374a1.366 1.366 0 0 1 1.688-.876",
    transform: "translate(-395.691 -263.362)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "m1254.5 836.5 3.3 1.131.187-6.761-1.6.095z",
    transform: "translate(-400.059 -264.967)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M883.474 507.292a2.514 2.514 0 0 0 0-5.029h.24a2.514 2.514 0 1 0 0 5.029z",
    transform: "translate(-281.013 -160.175)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M885.341 512.214a.933.933 0 0 1 .911.73l1.4 6.312a.932.932 0 0 1-.251.862l-1.933 1.932a.935.935 0 0 0-.264.527l-1.245 18.13h-3.708l-1.246-18.13a.935.935 0 0 0-.264-.527l-1.933-1.932a.933.933 0 0 1-.251-.862l1.4-6.312a.933.933 0 0 1 .911-.73z",
    transform: "translate(-279.527 -163.348)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(1047.901 553.23)",
    style: {
      opacity: 0.998
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M1545.473 817.292a2.514 2.514 0 0 0 0-5.029h.24a2.514 2.514 0 1 0 0 5.029z",
    transform: "translate(-1540.026 -812.263)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M1547.341 822.214a.933.933 0 0 1 .911.73l1.4 6.313a.932.932 0 0 1-.251.862l-1.933 1.932a.934.934 0 0 0-.264.527l-1.245 18.13h-3.708l-1.246-18.13a.933.933 0 0 0-.264-.527l-1.933-1.932a.933.933 0 0 1-.251-.862l1.4-6.312a.933.933 0 0 1 .911-.73z",
    transform: "translate(-1538.539 -815.436)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M278.286 819.356c0 1.8 4.214 3.268 9.412 3.268s9.412-1.463 9.412-3.268-4.214-3.268-9.412-3.268-9.412 1.463-9.412 3.268",
    transform: "translate(-88.745 -260.253)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M469.847 869.919c0 1.8 4.214 3.268 9.412 3.268s9.412-1.463 9.412-3.268-4.214-3.268-9.412-3.268-9.412 1.463-9.412 3.268",
    transform: "translate(-149.834 -276.377)",
    style: {
      fill: "#fcc800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M732.733 932.781h.013z",
    transform: "translate(-233.668 -297.466)",
    style: {
      strokeMiterlimit: 10,
      stroke: "#de7d7d",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(843.394 489.284)",
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    style: {
      clipPath: "url(#clip-path-10)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M1238.282 724.512c0 3.388 7.912 6.135 17.671 6.135s17.671-2.747 17.671-6.135-7.912-6.135-17.671-6.135-17.671 2.747-17.671 6.135",
    transform: "translate(-1238.281 -718.377)",
    style: {
      fill: "#27262d"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(582.534 368.729)",
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    style: {
      clipPath: "url(#clip-path-10)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M855.282 547.512c0 3.388 7.912 6.135 17.671 6.135s17.671-2.747 17.671-6.135-7.912-6.135-17.671-6.135-17.671 2.747-17.671 6.135",
    transform: "translate(-855.283 -541.377)",
    style: {
      fill: "#27262d"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(1066.08 560.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M1572.405 827.622a2.514 2.514 0 1 0-2.514-2.514 2.514 2.514 0 0 0 2.514 2.514",
    transform: "translate(-1566.716 -822.593)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M1567.565 832.544h7.662a.933.933 0 0 1 .923.8l.673 4.713a.932.932 0 0 1-.147.65l-3 4.5a.932.932 0 0 0-.157.518v17.317h-3.215l-2.607-18.13a.935.935 0 0 0-.264-.527l-1.933-1.932a.933.933 0 0 1-.251-.862l1.4-6.312a.933.933 0 0 1 .911-.73",
    transform: "translate(-1565.23 -825.766)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "m1108.672 536.558 92.022 31.784a.6.6 0 0 1 0 1.141l-54.563 20.2",
    transform: "translate(-353.554 -171.111)",
    style: {
      strokeWidth: 4,
      stroke: "#dd5b1b",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "m1157.209 191.067.1 18.871a6.343 6.343 0 0 0 8.487 5.936l107.1-38.469a16.255 16.255 0 0 1 10.831-.056l108.8 37.825a11.487 11.487 0 0 1 7.725 10.854v178.053a6.258 6.258 0 0 1-8.3 5.913l-73.267-25.133a8.776 8.776 0 0 0-5.6 0l-74.1 24.979",
    transform: "translate(-369.033 -56.273)",
    style: {
      stroke: "#16456c",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "m291.672 820.558 308.44 111.336a16.267 16.267 0 0 0 11.374-.123l223.024-86.012",
    transform: "translate(-93.014 -261.678)",
    style: {
      stroke: "#c28f4c",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "m476.672 856.889 180.975 64.728a16.265 16.265 0 0 0 11.253-.11l252.531-95.949",
    transform: "translate(-152.01 -263.273)",
    style: {
      stroke: "#fcc800",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "m1064.672 456.747 155.5 54a6.257 6.257 0 0 0 8.3-5.913V278.42a11.489 11.489 0 0 0-7.725-10.855l-97.914-33.945a9.327 9.327 0 0 1-6.272-8.812v-32.5",
    transform: "translate(-339.523 -61.331)",
    style: {
      strokeWidth: 4,
      stroke: "#dd5b1b",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "m1201.124 637.675 91.345 31.619a6.258 6.258 0 0 0 8.3-5.913V257.16a11.487 11.487 0 0 0-7.725-10.854l-97.914-33.945a9.326 9.326 0 0 1-6.272-8.812v-20.237",
    transform: "translate(-379.127 -58.461)",
    style: {
      stroke: "#175157",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "m1120.758 567.433 27.98 9.129a9.353 9.353 0 0 0 12.347-8.861V293.094a10.526 10.526 0 0 0-7.111-9.956l-87.929-30.158a4.1 4.1 0 0 1-.089-7.724l32.333-11.929a13.156 13.156 0 0 0 8.6-12.342V189.13",
    transform: "translate(-339.077 -60.317)",
    style: {
      stroke: "#dfa4b8",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M862.828 176.641v45.091a3.541 3.541 0 0 1-2.328 3.319L370.291 402.8a7.377 7.377 0 0 0 .406 14l71.07 21.2a7.378 7.378 0 0 1 5.268 7.069v173.949",
    transform: "translate(-116.535 -56.334)",
    style: {
      stroke: "#fcc800",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M292.171 579.573V414.779a32.294 32.294 0 0 1 21.229-30.272L824.46 199.2a8.3 8.3 0 0 0 5.471-7.8v-29.342",
    transform: "translate(-93.173 -51.684)",
    style: {
      stroke: "#c28f4c",
      strokeWidth: 4,
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M1169.319 42.567c0-.057-.006-.114-.008-.172 0-.115-.01-.23-.016-.345 0-.1-.007-.195-.013-.292-.005-.08-.014-.159-.02-.239q-.014-.192-.031-.384c-.007-.076-.011-.151-.018-.225-.009-.095-.022-.189-.033-.283-.015-.133-.03-.266-.047-.4-.008-.061-.013-.121-.021-.181-.014-.1-.031-.2-.046-.294a17.597 17.597 0 0 0-.072-.46c-.01-.056-.016-.112-.026-.168-.016-.091-.037-.18-.053-.271l-.1-.528c-.013-.062-.023-.125-.037-.187l-.053-.223c-.046-.2-.094-.406-.144-.608-.019-.074-.034-.149-.053-.223-.014-.05-.03-.1-.043-.149q-.121-.452-.257-.9c-.015-.05-.027-.1-.043-.152 0-.011-.008-.021-.011-.032a25.726 25.726 0 0 0-.439-1.28c-.017-.046-.031-.094-.048-.14s-.044-.108-.065-.163l-.3-.746-.115-.279a28.584 28.584 0 0 0-.448-.992c0-.01-.008-.02-.013-.029-.022-.046-.048-.091-.069-.138q-.2-.41-.41-.812l-.168-.311q-.184-.338-.375-.669l-.177-.3q-.231-.386-.474-.764c-.034-.052-.066-.106-.1-.159q-.294-.451-.6-.886l-.044-.065c-.044-.061-.091-.12-.135-.18-.149-.2-.3-.405-.452-.6-.073-.1-.148-.191-.224-.285-.149-.188-.3-.373-.456-.556l-.143-.174c-.02-.022-.042-.044-.061-.067q-.427-.492-.875-.956c-.025-.025-.048-.054-.073-.08-.043-.045-.09-.086-.134-.131q-.293-.3-.6-.58c-.047-.044-.091-.092-.139-.136l-.079-.069a22.574 22.574 0 0 0-.574-.506c-.046-.039-.089-.08-.135-.119l-.025-.02a19.635 19.635 0 0 0-.539-.433c-.051-.04-.1-.082-.151-.121l-.008-.005c-.127-.1-.258-.19-.387-.285-.1-.074-.2-.151-.3-.222h-.005l-.114-.076a19.714 19.714 0 0 0-.553-.37l-.026-.016c-.063-.04-.128-.078-.192-.117-.144-.089-.289-.18-.435-.265l-.064-.035c-.083-.047-.166-.092-.25-.138-.112-.062-.224-.127-.337-.187l-.113-.056c-.087-.045-.175-.088-.263-.131s-.174-.089-.261-.131c-.059-.028-.12-.052-.179-.08l-.276-.123c-.063-.028-.125-.058-.189-.084-.086-.036-.174-.067-.26-.1s-.176-.071-.265-.1c-.041-.015-.08-.033-.121-.048a15.747 15.747 0 0 0-.554-.191L1093.526.646l-.1-.033q-.335-.105-.666-.192c-.082-.022-.163-.038-.245-.058l-.2-.048c-.073-.016-.148-.037-.222-.052q-.345-.072-.685-.123l-.053-.007-.131-.016c-.175-.025-.35-.048-.524-.065-.1-.01-.2-.012-.306-.019-.08 0-.159-.011-.239-.014-.059 0-.118-.01-.177-.011-.229-.007-.455 0-.679 0H1089.181q-.431.018-.852.07l-.062.011c-.152.02-.3.05-.448.076s-.3.045-.449.078c-.02 0-.04.012-.06.017a9.819 9.819 0 0 0-1.084.312c-.017.006-.035.009-.052.015q-.4.143-.781.318l-21.9 10.044c.271-.124.55-.233.833-.333a9.992 9.992 0 0 1 1.084-.312c.168-.038.339-.065.51-.095.148-.026.3-.057.446-.076.307-.04.617-.068.932-.081h.1q.423-.013.856.007c.079 0 .159.01.238.015.275.018.551.044.83.083l.132.016c.317.047.637.11.96.183l.2.048c.334.081.671.172 1.011.282l60.847 19.68c.226.073.451.154.674.238.089.033.176.069.264.1q.227.09.451.187c.092.04.183.08.274.123.148.067.3.138.443.21.087.044.174.086.261.131.152.078.3.16.452.243.083.046.166.09.249.137l.5.3c.064.04.129.077.192.117.2.126.394.257.589.392l.1.069c.105.074.208.153.313.228.129.094.258.185.385.283.051.039.1.081.151.121.184.144.368.289.548.439.055.045.107.093.161.139.194.166.386.333.574.506.074.067.146.138.219.206q.3.284.6.58l.206.21q.447.464.874.956c.069.08.136.161.2.242q.231.273.455.554c.076.1.151.191.226.287.153.2.3.4.452.6.059.082.12.162.178.245.207.292.409.586.605.887l.1.155q.243.379.475.767c.06.1.119.2.178.305q.191.331.374.668c.056.1.113.207.168.312q.211.4.41.812c.027.056.056.11.083.167q.234.49.448.991c.04.094.078.189.116.283q.154.369.3.743a32.686 32.686 0 0 1 .553 1.585l.055.184q.137.447.257.9c.033.124.065.249.1.373q.076.3.144.607c.031.137.061.273.09.41.037.176.071.353.1.529.027.146.055.292.079.438s.049.306.072.458a19.113 19.113 0 0 1 .114.879c.019.17.037.339.052.509q.017.192.031.384c.013.177.024.353.033.531.006.115.012.23.016.345.009.266.016.532.016.8v73.314c0 .369-.011.732-.029 1.09 0 .075-.01.149-.014.224q-.027.429-.069.845l-.02.2q-.056.485-.135.955c-.012.072-.026.142-.039.213q-.067.376-.15.741a16.013 16.013 0 0 1-.296 1.147v.012c-.09.3-.189.588-.295.873-.038.1-.08.205-.121.308-.072.182-.145.363-.223.539-.059.133-.122.263-.185.393-.069.146-.14.291-.215.432-.1.183-.2.358-.3.533-.062.1-.122.212-.186.315q-.316.5-.67.963c-.054.07-.11.136-.165.2q-.29.359-.6.687c-.065.067-.128.137-.193.2a10.58 10.58 0 0 1-.813.736c-.046.037-.1.07-.142.106q-.369.287-.76.537c-.082.052-.164.1-.247.155a9.92 9.92 0 0 1-.955.512l21.9-10.044a9.752 9.752 0 0 0 .956-.512c.084-.05.166-.1.249-.155q.39-.25.759-.537c.047-.036.1-.069.142-.106a10.559 10.559 0 0 0 .813-.736c.065-.065.129-.135.193-.2.208-.219.41-.448.6-.688.037-.046.08-.085.116-.132.018-.022.032-.048.049-.07q.353-.46.67-.964c.014-.022.031-.042.045-.065.049-.079.091-.166.139-.248.1-.175.2-.351.3-.535.024-.044.05-.085.073-.13.05-.1.093-.2.141-.3.063-.13.125-.259.185-.394.02-.046.044-.09.064-.136.056-.13.105-.267.158-.4.041-.1.084-.205.123-.311.011-.029.024-.058.034-.088q.139-.383.26-.783v-.007q.108-.359.2-.729c.014-.053.024-.108.037-.162.021-.086.04-.174.059-.261.024-.108.052-.215.074-.324.027-.136.05-.276.075-.414.013-.072.027-.143.039-.215l.02-.108q.059-.366.1-.742c0-.035.007-.071.011-.106l.02-.2c.016-.147.033-.293.045-.442.011-.133.017-.27.025-.4 0-.075.01-.149.014-.225 0-.044.006-.089.008-.134q.017-.384.02-.778V43.187q0-.313-.009-.625",
    transform: "translate(-339.148 -.005)",
    style: {
      fill: "#0494c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M1129.276 35.073c8.258 2.671 14.956 12.91 14.956 22.867v73.314c0 9.956-6.7 15.862-14.958 13.191l-60.847-19.68c-8.262-2.673-14.956-12.91-14.956-22.867V28.584c0-9.956 6.7-15.864 14.958-13.192z",
    transform: "translate(-335.949 -4.707)",
    style: {
      fill: "#00a2d2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    transform: "translate(741.638 32.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    style: {
      clipPath: "url(#clip-path-12)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M1121.61 60.088a3.922 3.922 0 0 0-.294-.1l-19.4-6.455a6.748 6.748 0 0 0-7.115 1.506c-1.915 1.846-2.988 4.777-3.022 8.247l-.374 17.835a15.574 15.574 0 0 0 3.723 10.334l16.508 15.246-.026.072 15.669 14.473-31.028-10.32 5.865-5.983-5.683-5.244-4.881 4.985a7.006 7.006 0 0 0-1.636 5.575c.294 3.629 2.549 7.064 5.291 8.105.069.026.138.05.208.074l33.152 11.027c2.906.964 5.4-1.014 5.793-4.6a10.583 10.583 0 0 0-3.4-8.852l-20.833-19.24.057-.066-5.678-5.242-.061.064-5.968-5.516a4.128 4.128 0 0 1-1.131-2.915l.371-17.865v-.063a6.07 6.07 0 0 1 .126-1.189l.08-3.862 2.991 1a3.129 3.129 0 0 1 .836.16l19.4 6.455.093.033a2.193 2.193 0 0 1 .432.225l4.608 1.533-6.977 6.833-11.188 11.419 5.683 5.244 13.507-13.783.1-.127a10.015 10.015 0 0 0 1.794-5.854c.119-5.7-3.263-11.515-7.594-13.159",
    transform: "translate(-1089.199 -49.027)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M1163.739 854.646a2.405 2.405 0 1 0-2.406-2.406 2.406 2.406 0 0 0 2.406 2.406",
    transform: "translate(-370.348 -271.015)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M1159.108 859.355h7.33a.892.892 0 0 1 .883.766l.644 4.509a.894.894 0 0 1-.141.621l-2.868 4.3a.893.893 0 0 0-.15.5v16.568h-3.076l-2.495-17.346a.893.893 0 0 0-.252-.5l-1.849-1.849a.891.891 0 0 1-.24-.824l1.342-6.039a.892.892 0 0 1 .871-.7",
    transform: "translate(-368.926 -274.051)",
    style: {
      fill: "#27262d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M1197.115 849.545c0 1.374 2.906 2.487 6.49 2.487s6.49-1.114 6.49-2.487-2.906-2.487-6.49-2.487-6.49 1.114-6.49 2.487",
    transform: "translate(-381.759 -270.129)",
    style: {
      fill: "#175157"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M1138.115 743.545c0 1.374 2.906 2.487 6.49 2.487s6.49-1.114 6.49-2.487-2.906-2.487-6.49-2.487-6.49 1.114-6.49 2.487",
    transform: "translate(-362.944 -236.326)",
    style: {
      fill: "#e1a4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M902.172 442.772v282.571l37.452 12.831V692.5a3.433 3.433 0 0 1 4.6-3.229l32.4 11.7a3.434 3.434 0 0 1 2.267 3.229v47.429l37.452 12.831v-282.5z",
    transform: "translate(-287.702 -141.203)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M290.647 774.9a2.514 2.514 0 0 0 0-5.029h.24a2.514 2.514 0 1 0 0 5.029z",
    transform: "translate(-91.962 -245.516)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M292.515 779.826a.933.933 0 0 1 .911.73l1.4 6.312a.933.933 0 0 1-.251.862l-1.933 1.932a.935.935 0 0 0-.264.527l-1.245 18.13h-3.708l-1.246-18.13a.936.936 0 0 0-.264-.527l-1.933-1.932a.933.933 0 0 1-.251-.862l1.4-6.312a.933.933 0 0 1 .911-.73z",
    transform: "translate(-90.476 -248.689)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M1104.483 537.509c0 1.374 2.906 2.487 6.489 2.487s6.49-1.114 6.49-2.487-2.906-2.487-6.49-2.487-6.489 1.114-6.489 2.487",
    transform: "translate(-352.218 -170.621)",
    style: {
      fill: "#de5b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M1268.483 517.509c0 1.374 2.906 2.487 6.489 2.487s6.49-1.114 6.49-2.487-2.906-2.487-6.49-2.487-6.489 1.114-6.489 2.487",
    transform: "translate(-404.518 -164.243)",
    style: {
      fill: "#16456c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M483.96 827.423a2.405 2.405 0 1 0-2.406-2.406 2.406 2.406 0 0 0 2.406 2.406",
    transform: "translate(-153.567 -262.333)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M479.329 832.132h7.33a.892.892 0 0 1 .883.766l.644 4.509a.894.894 0 0 1-.141.621l-2.868 4.3a.893.893 0 0 0-.15.5v16.568h-3.076l-2.495-17.346a.891.891 0 0 0-.252-.5l-1.849-1.849a.891.891 0 0 1-.24-.824l1.342-6.039a.892.892 0 0 1 .871-.7",
    transform: "translate(-152.145 -265.369)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(546.728 492.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M809.647 727.9a2.514 2.514 0 0 0 0-5.029h.24a2.514 2.514 0 1 0 0 5.029z",
    transform: "translate(-804.198 -722.875)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M811.515 732.826a.933.933 0 0 1 .911.73l1.4 6.312a.933.933 0 0 1-.251.862l-1.933 1.932a.935.935 0 0 0-.264.527l-1.245 18.13h-3.708l-1.246-18.13a.936.936 0 0 0-.264-.527l-1.933-1.932a.933.933 0 0 1-.251-.862l1.4-6.312a.933.933 0 0 1 .911-.73z",
    transform: "translate(-802.712 -726.048)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(684.568 632.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M1011.96 933.423a2.405 2.405 0 1 0-2.406-2.406 2.406 2.406 0 0 0 2.406 2.406",
    transform: "translate(-1006.514 -928.612)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M1007.329 938.132h7.33a.892.892 0 0 1 .883.766l.644 4.509a.894.894 0 0 1-.141.621l-2.868 4.3a.893.893 0 0 0-.15.5v16.568h-3.076l-2.495-17.346a.891.891 0 0 0-.252-.5l-1.849-1.849a.891.891 0 0 1-.24-.824l1.342-6.039a.892.892 0 0 1 .871-.7",
    transform: "translate(-1005.092 -931.648)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M1078.888 856.84c0 1.325 3.093 2.4 6.908 2.4s6.908-1.073 6.908-2.4-3.093-2.4-6.908-2.4-6.908 1.073-6.908 2.4",
    transform: "translate(-344.056 -272.484)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M1118.011 823.431c0 1.447 3.379 2.62 7.547 2.62s7.547-1.173 7.547-2.62-3.379-2.62-7.547-2.62-7.547 1.173-7.547 2.62",
    transform: "translate(-356.533 -261.759)",
    style: {
      fill: "#fcc800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M1429.773 192.447a5.928 5.928 0 0 1 3.57 5.458v17.5c0 2.376-1.6 3.786-3.57 3.149l-63.735-21.44a5.929 5.929 0 0 1-3.57-5.458v-17.5c0-2.376 1.6-3.786 3.57-3.149z",
    transform: "translate(-434.489 -54.489)",
    style: {
      fill: "#11456c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(943.689 129.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768",
    style: {
      clipPath: "url(#clip-path-15)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "m1390.54 192.757-1.077-.319-.159 4.3c-.056 1.507-.489 1.845-1.317 1.6-.85-.251-1.167-.895-1.118-2.227l.163-4.392-1.077-.319-.166 4.492c-.069 1.869.712 3.1 2.15 3.529 1.521.451 2.368-.356 2.438-2.254z",
    transform: "translate(-1385.614 -190.891)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M1396.168 201.812c-.707-.21-1.144-.906-1.1-2.092v-.082c.044-1.18.546-1.616 1.22-1.416.638.189 1.1.91 1.054 2.09v.082c-.042 1.133-.458 1.63-1.174 1.418m.409-4.479a1.2 1.2 0 0 0-1.409.557l.031-.853-.97-.287-.264 7.126.971.287.1-2.646a2.114 2.114 0 0 0 1.338 1.336c1.086.321 1.9-.482 1.964-2.188v-.082c.063-1.712-.71-2.938-1.763-3.25",
    transform: "translate(-1388.223 -192.597)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M1402.948 199.345a1.156 1.156 0 0 0-1.631 1.129c-.037.992.355 1.51 1.456 2.061.614.317.891.565.875 1-.016.45-.261.613-.783.458a1.061 1.061 0 0 1-.805-1.1l-.915-.271a2.228 2.228 0 0 0 1.7 2.274c1.077.319 1.7-.123 1.74-1.2.042-1.127-.534-1.605-1.511-2.09-.665-.339-.858-.549-.844-.934s.273-.557.689-.434a.964.964 0 0 1 .723.934l.9.266a2.1 2.1 0 0 0-1.586-2.094",
    transform: "translate(-1390.513 -193.401)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "m1408.615 197.372-.975-.289-.287 7.762.975.289.1-2.611 1.475 3.077 1.128.334-1.665-3.4 1.723-1.953-1.058-.313-1.589 1.891z",
    transform: "translate(-1392.492 -192.704)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "m1414.925 201.856-.971-.287-.2 5.309.971.287zm-.41-2.43c-.323-.1-.589.133-.6.541a.875.875 0 0 0 .552.872c.319.095.589-.132.6-.53a.886.886 0 0 0-.552-.883",
    transform: "translate(-1394.535 -193.444)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "m1418.214 200.215-.971-.287-.287 7.763.971.287z",
    transform: "translate(-1395.555 -193.611)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "m1421.41 201.162-.971-.287-.287 7.763.971.287z",
    transform: "translate(-1396.574 -193.913)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "m1424.516 204.7-.971-.287-.2 5.309.971.287zm-.41-2.43c-.324-.1-.59.133-.6.541a.877.877 0 0 0 .552.872c.319.095.589-.132.6-.53a.888.888 0 0 0-.552-.883",
    transform: "translate(-1397.594 -194.35)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M1429.042 206.938a1.093 1.093 0 0 0-1.394.55l.031-.841-.971-.287-.2 5.309.971.287.116-3.125c.031-.841.49-1.136 1.036-.975.578.172.823.61.794 1.411l-.12 3.23.971.287.124-3.341c.054-1.46-.52-2.256-1.361-2.505",
    transform: "translate(-1398.603 -195.662)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M1435.436 213.315a1.817 1.817 0 0 1-1.05-1.923v-.082c.036-.964.481-1.5 1.2-1.286a1.771 1.771 0 0 1 1.073 1.942v.07c-.037 1.016-.55 1.479-1.225 1.278m-.059-4.328c-1.082-.32-1.927.557-1.983 2.052v.07a2.95 2.95 0 0 0 1.769 3.081 1.213 1.213 0 0 0 1.409-.58l-.029.783c-.035.952-.469 1.308-1.227 1.083a1.272 1.272 0 0 1-1-1.142l-.98-.29a2.539 2.539 0 0 0 1.96 2.369c1.3.386 2.16-.151 2.222-1.715l.182-4.912-.97-.287-.03.812a2.012 2.012 0 0 0-1.316-1.323",
    transform: "translate(-1400.776 -196.479)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M1240.457 267.818a5.928 5.928 0 0 1 3.57 5.458v17.5c0 2.376-1.6 3.786-3.57 3.149l-63.735-21.44a5.929 5.929 0 0 1-3.57-5.458v-17.5c0-2.376 1.6-3.786 3.57-3.149z",
    transform: "translate(-374.117 -78.524)",
    style: {
      fill: "#dd5b1b"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773",
    transform: "translate(824.838 184.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    style: {
      clipPath: "url(#clip-path-17)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "m1212.377 271.285-1.068-.316-.268 7.26 3.518 1.041.04-1.08-2.45-.725z",
    transform: "translate(-1211.037 -270.46)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M1218.662 280.776a.859.859 0 0 1-.647-.941c.024-.648.508-.724 1.248-.5l.5.148-.02.532a.762.762 0 0 1-1.08.766m.5-4.539a1.3 1.3 0 0 0-1.867 1.218l.943.279c.065-.512.326-.742.83-.593.573.17.754.584.728 1.29l-.01.274-.522-.155c-1.207-.358-2.171-.188-2.217 1.05a1.861 1.861 0 0 0 1.347 1.987 1.076 1.076 0 0 0 1.313-.373l-.024.654.957.284.129-3.481a2.181 2.181 0 0 0-1.606-2.436",
    transform: "translate(-1212.953 -272.109)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M1226.105 281.567c-.707-.209-1.144-.9-1.1-2.091v-.082c.043-1.174.546-1.61 1.22-1.41.633.187 1.1.909 1.054 2.083v.082c-.042 1.139-.458 1.63-1.174 1.417m-.877-7.227-.971-.287-.287 7.768.971.287.031-.853a2.084 2.084 0 0 0 1.338 1.359c1.086.321 1.9-.482 1.964-2.188v-.082c.063-1.717-.709-2.938-1.763-3.25a1.2 1.2 0 0 0-1.409.557l.123-3.312",
    transform: "translate(-1215.161 -271.443)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M1232.854 280.258a1.158 1.158 0 0 0-1.635 1.122c-.037 1 .36 1.517 1.461 2.068.615.312.886.557.87 1s-.256.609-.778.454a1.063 1.063 0 0 1-.805-1.1l-.915-.271a2.234 2.234 0 0 0 1.7 2.28c1.077.319 1.7-.122 1.74-1.2.042-1.127-.534-1.605-1.516-2.091-.66-.343-.853-.554-.839-.939s.273-.551.689-.428a.954.954 0 0 1 .719.927l.9.267a2.087 2.087 0 0 0-1.586-2.088",
    transform: "translate(-1217.418 -273.398)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2774",
    "data-name": "Group 2774",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M1285.457 236.818a5.928 5.928 0 0 1 3.57 5.458v17.5c0 2.376-1.6 3.786-3.57 3.149l-63.735-21.44a5.929 5.929 0 0 1-3.57-5.458v-17.5c0-2.376 1.6-3.786 3.57-3.149z",
    transform: "translate(-388.467 -68.638)",
    style: {
      fill: "#175157"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777",
    transform: "translate(843.202 159.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    style: {
      clipPath: "url(#clip-path-19)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "m1239.808 240.016.979-3.117.717 3.619zm1.783-3.995-1.4-.415-2.191 6.687 1 .3.519-1.659 2.191.649.392 1.928 1.109.329-1.627-7.816",
    transform: "translate(-1238 -235.039)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "m1252.247 241.762-.947-.281-1.016 3.579-.68-4.081-.809-.239-1.034 3.573-.695-4.085-1.035-.306 1.088 5.689 1 .3.983-3.322.644 3.8.989.293z",
    transform: "translate(-1240.559 -236.415)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M1257.026 247.948a.85.85 0 0 1-.647-.941c.024-.648.5-.719 1.242-.5l.5.148-.019.525a.759.759 0 0 1-1.076.768m.5-4.541a1.3 1.3 0 0 0-1.864 1.226l.939.278c.065-.518.327-.747.835-.6.568.168.75.582.723 1.295l-.01.274-.522-.155c-1.206-.358-2.17-.194-2.216 1.044a1.862 1.862 0 0 0 1.347 1.992 1.081 1.081 0 0 0 1.313-.373l-.024.648.957.284.129-3.481a2.187 2.187 0 0 0-1.606-2.437",
    transform: "translate(-1243.55 -237.496)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M1264.866 245.443a1.077 1.077 0 0 0-1.408.676l.037-1-.971-.287-.2 5.309.971.287.1-2.763c.042-1.122.567-1.314 1.424-1.073z",
    transform: "translate(-1245.757 -237.981)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M1267.656 248.664c.123-.8.539-1.175 1.121-1 .605.179.96.7.973 1.622zm1.155-1.9c-1.2-.355-2.126.481-2.186 2.122v.082a3.151 3.151 0 0 0 2.026 3.334c1.077.319 1.816-.082 1.991-1.158l-.938-.278c-.093.5-.409.7-1 .526-.721-.213-1.1-.9-1.1-1.913l3.079.911.014-.356c.07-1.9-.844-2.96-1.889-3.269",
    transform: "translate(-1247.125 -238.573)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M1276.26 248.788a1.087 1.087 0 0 0-1.39.556l.031-.847-.975-.289-.2 5.309.975.289.116-3.125c.031-.841.486-1.137 1.031-.976.582.173.823.61.793 1.416l-.119 3.224.97.287.124-3.341c.054-1.46-.515-2.254-1.361-2.505",
    transform: "translate(-1249.393 -239.058)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M1281.664 252.814c.128-.795.539-1.175 1.126-1s.956.7.973 1.622zm1.159-1.895c-1.2-.355-2.13.479-2.191 2.12v.082a3.156 3.156 0 0 0 2.031 3.335 1.378 1.378 0 0 0 1.992-1.158l-.938-.278c-.093.5-.409.7-1 .526-.721-.213-1.1-.9-1.1-1.913l3.075.911.013-.357c.07-1.9-.839-2.959-1.884-3.268",
    transform: "translate(-1251.592 -239.896)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M1289.224 252.763a1.161 1.161 0 0 0-1.635 1.128c-.037.993.36 1.512 1.461 2.062.615.317.886.563.87 1-.016.45-.256.614-.778.46a1.061 1.061 0 0 1-.805-1.1l-.915-.271a2.234 2.234 0 0 0 1.7 2.28c1.078.319 1.7-.123 1.741-1.2.042-1.127-.534-1.605-1.516-2.091-.66-.337-.853-.548-.839-.933s.273-.557.689-.434a.964.964 0 0 1 .722.934l.9.266a2.094 2.094 0 0 0-1.586-2.094",
    transform: "translate(-1253.759 -240.486)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M1295.055 254.489a1.16 1.16 0 0 0-1.635 1.128c-.037.993.356 1.511 1.457 2.061.615.317.89.565.874 1-.016.449-.256.614-.779.46a1.054 1.054 0 0 1-.805-1.1l-.915-.271a2.233 2.233 0 0 0 1.692 2.278c1.077.319 1.705-.121 1.745-1.2.042-1.127-.534-1.6-1.516-2.091-.66-.337-.858-.549-.844-.934s.273-.557.694-.432a.956.956 0 0 1 .718.933l.9.267a2.1 2.1 0 0 0-1.586-2.094",
    transform: "translate(-1255.618 -241.036)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M1148.184 292.4a5.929 5.929 0 0 1 3.57 5.458v17.5c0 2.376-1.6 3.786-3.57 3.149l-63.735-21.44a5.929 5.929 0 0 1-3.57-5.458v-17.5c0-2.376 1.6-3.786 3.57-3.149z",
    transform: "translate(-344.691 -86.363)",
    style: {
      fill: "#dfa4b8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(752.478 198.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    style: {
      clipPath: "url(#clip-path-21)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "m1106.115 295.264.086-2.319.86.255a1.3 1.3 0 0 1 1.054 1.446v.041c-.029.771-.422 1.044-1.139.832zm.984-3.11-1.927-.571-.268 7.26 1.067.316.108-2.932.685.2 1.393 3.377 1.156.343-1.5-3.615c.725-.021 1.306-.434 1.348-1.573v-.041a2.638 2.638 0 0 0-2.066-2.767",
    transform: "translate(-1104.831 -291.081)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M1113.04 299.112c.128-.795.539-1.175 1.126-1s.956.691.969 1.621zm1.159-1.895c-1.2-.355-2.13.479-2.191 2.12v.082a3.149 3.149 0 0 0 2.026 3.329c1.078.319 1.817-.076 1.992-1.152l-.939-.278c-.093.5-.409.7-.991.527-.726-.215-1.107-.9-1.1-1.915l3.079.911.013-.356c.07-1.9-.839-2.959-1.884-3.268",
    transform: "translate(-1107.095 -292.852)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M1120.6 299.061a1.157 1.157 0 0 0-1.635 1.128c-.037.993.356 1.51 1.457 2.061.614.317.89.565.874 1-.016.45-.256.614-.778.46a1.053 1.053 0 0 1-.805-1.1l-.915-.272a2.226 2.226 0 0 0 1.692 2.273c1.077.319 1.706-.121 1.745-1.2.042-1.127-.534-1.605-1.516-2.091-.66-.337-.858-.549-.844-.934s.273-.557.693-.432a.954.954 0 0 1 .718.933l.9.267a2.1 2.1 0 0 0-1.586-2.094",
    transform: "translate(-1109.262 -293.442)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "m1126.263 297.087-.971-.287-.287 7.763.971.287.1-2.611 1.48 3.078 1.123.332-1.66-3.4 1.718-1.954-1.058-.313-1.589 1.891z",
    transform: "translate(-1111.241 -292.744)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "m1132.577 301.571-.975-.289-.2 5.309.975.289zm-.415-2.432c-.323-.1-.589.133-.6.541a.875.875 0 0 0 .552.872c.324.1.589-.132.6-.53a.881.881 0 0 0-.552-.883",
    transform: "translate(-1113.282 -293.484)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "m1135.867 299.931-.97-.287-.287 7.763.971.287z",
    transform: "translate(-1114.304 -293.651)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "m1139.063 300.877-.971-.287-.287 7.763.97.287z",
    transform: "translate(-1115.323 -293.953)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "m1142.169 304.412-.971-.287-.2 5.309.971.287zm-.415-2.432c-.319-.095-.589.133-.6.541a.88.88 0 0 0 .552.872c.323.1.589-.132.6-.53a.881.881 0 0 0-.552-.883",
    transform: "translate(-1116.343 -294.39)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M1146.688 306.652a1.088 1.088 0 0 0-1.389.551l.031-.841-.975-.289-.2 5.309.975.289.116-3.125c.031-.841.486-1.137 1.031-.976.582.173.823.61.793 1.411l-.119 3.23.97.287.124-3.341c.054-1.46-.515-2.254-1.361-2.505",
    transform: "translate(-1117.349 -295.702)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M1153.089 313.031a1.812 1.812 0 0 1-1.05-1.923v-.082c.035-.964.476-1.5 1.2-1.286a1.771 1.771 0 0 1 1.073 1.942v.07c-.037 1.016-.55 1.479-1.225 1.278m-.059-4.328c-1.086-.321-1.932.556-1.988 2.051v.07a2.946 2.946 0 0 0 1.77 3.075 1.219 1.219 0 0 0 1.413-.574l-.029.783c-.035.952-.473 1.306-1.227 1.083a1.269 1.269 0 0 1-1-1.142l-.979-.29a2.535 2.535 0 0 0 1.959 2.37c1.3.384 2.156-.153 2.222-1.716l.182-4.912-.971-.287-.03.812a2.027 2.027 0 0 0-1.316-1.323",
    transform: "translate(-1119.526 -296.52)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M538.743 417.208a5.928 5.928 0 0 0-3.57 5.458v17.5c0 2.376 1.6 3.786 3.57 3.149l63.735-23.483a5.929 5.929 0 0 0 3.57-5.458v-17.5c0-2.376-1.6-3.786-3.57-3.149z",
    transform: "translate(-170.666 -125.513)",
    style: {
      fill: "#fcc800"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785",
    transform: "translate(380.291 281.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784",
    style: {
      clipPath: "url(#clip-path-23)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M561 440.182c-.9.331-1.577-.454-1.6-2.036v-.082c-.022-1.565.541-2.823 1.513-3.179s1.558.544 1.579 2.032V437c.023 1.576-.553 2.839-1.492 3.183m-.1-6.372c-1.474.542-2.49 2.5-2.46 4.619v.082c.03 2.09 1.043 3.315 2.566 2.756 1.507-.553 2.479-2.506 2.448-4.631v-.076c-.031-2.13-1.075-3.291-2.553-2.748",
    transform: "translate(-558.374 -419.967)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M568.976 433.809a2.035 2.035 0 0 0-1.161 1.383l-.012-.84-.839.308.076 5.307.839-.308-.045-3.124a1.553 1.553 0 0 1 .836-1.581c.5-.183.729.1.74.9l.046 3.223.839-.309-.048-3.339c-.021-1.46-.545-1.889-1.272-1.622",
    transform: "translate(-561.095 -419.985)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M575.027 435.293c-.612.224-1.015-.191-1.032-1.377v-.082c-.017-1.179.39-1.91.973-2.124.548-.2.971.224.988 1.4v.082c.016 1.133-.315 1.87-.93 2.1m-1.078-6.53-.843.309.112 7.76.843-.309-.012-.853a.881.881 0 0 0 1.2.516c.935-.343 1.6-1.624 1.571-3.329v-.082c-.025-1.711-.742-2.44-1.649-2.107a2.271 2.271 0 0 0-1.173 1.4l-.048-3.3",
    transform: "translate(-563.054 -418.399)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M581.2 433.93c-.639.234-1.016-.308-1.032-1.394v-.082c-.016-1.1.358-1.9.982-2.127s1.009.305 1.024 1.4v.069c.016 1.086-.347 1.9-.974 2.13m-.065-4.566a3.494 3.494 0 0 0-1.827 3.423v.082c.023 1.618.83 2.407 1.9 2.015a3.463 3.463 0 0 0 1.83-3.413v-.082c-.024-1.623-.839-2.416-1.9-2.026",
    transform: "translate(-565.033 -418.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M586.961 431.912c-.415.153-.587-.078-.594-.527-.009-.648.4-1.008 1.035-1.242l.432-.159.007.526a1.42 1.42 0 0 1-.88 1.4m.217-4.74a2.417 2.417 0 0 0-1.529 2.328l.811-.3a1.113 1.113 0 0 1 .683-1.09c.492-.18.664.114.675.827v.274l-.451.165a2.449 2.449 0 0 0-1.838 2.365c.016 1.109.573 1.368 1.241 1.124a1.906 1.906 0 0 0 1.1-1.155l.009.648.823-.3-.05-3.48c-.02-1.448-.663-1.7-1.478-1.406",
    transform: "translate(-567.017 -417.857)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M593.521 424.875a2.058 2.058 0 0 0-1.167 1.514l-.014-1-.839.309.076 5.307.838-.308-.039-2.762a1.73 1.73 0 0 1 1.161-1.911z",
    transform: "translate(-568.92 -417.159)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M596.99 426.764c-.544.2-.955-.213-.972-1.381v-.083c-.016-1.145.334-1.907.954-2.135s.987.219 1 1.386v.082c.017 1.185-.407 1.915-.986 2.128m1.727-7.56-.843.309.047 3.264a.848.848 0 0 0-1.171-.5c-.943.347-1.615 1.673-1.59 3.372v.076c.025 1.729.726 2.417 1.633 2.083a2.266 2.266 0 0 0 1.18-1.431l.013.893.843-.309-.112-7.76",
    transform: "translate(-570.086 -415.351)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "m602.717 420.8-.839.309.076 5.307.839-.308zm-.46-2.126a.941.941 0 0 0-.489.9c.005.4.229.62.509.517a.938.938 0 0 0 .489-.883c-.005-.409-.234-.631-.51-.529",
    transform: "translate(-572.194 -415.173)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M606.676 419.968a2.045 2.045 0 0 0-1.161 1.383l-.012-.841-.839.309.076 5.307.839-.309-.045-3.124a1.552 1.552 0 0 1 .836-1.58c.5-.183.729.1.74.9l.046 3.223.839-.309-.048-3.34c-.021-1.46-.545-1.889-1.272-1.622",
    transform: "translate(-573.117 -415.571)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M612.4 421.966c-.543.2-.968-.255-.982-1.242v-.082a1.959 1.959 0 0 1 .964-1.985c.6-.221.988.242 1 1.246v.07a1.98 1.98 0 0 1-.984 1.993m-.249-4.193c-.935.343-1.614 1.714-1.592 3.209v.069c.023 1.53.736 2.272 1.647 1.937a2.315 2.315 0 0 0 1.172-1.422l.011.783a1.68 1.68 0 0 1-.994 1.8c-.548.2-.828 0-.907-.506l-.847.311c.114.979.636 1.545 1.775 1.127a2.912 2.912 0 0 0 1.812-3.025l-.071-4.91-.839.308.012.812a.854.854 0 0 0-1.18-.494",
    transform: "translate(-574.997 -414.695)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2787",
    "data-name": "Group 2787",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M373.743 439.208a5.928 5.928 0 0 0-3.57 5.458v17.5c0 2.376 1.6 3.786 3.57 3.149l63.735-23.483a5.929 5.929 0 0 0 3.57-5.458v-17.5c0-2.376-1.6-3.786-3.57-3.149z",
    transform: "translate(-118.048 -132.529)",
    style: {
      fill: "#c28f4c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789",
    transform: "translate(260.665 293.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788",
    style: {
      clipPath: "url(#clip-path-25)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "m383.7 464.324-.035-2.476.675-.248c.587-.215.94-.01.952.854v.041a1.5 1.5 0 0 1-.917 1.581zm.625-3.769-1.6.586.1 7.258.923-.339-.039-2.761.695-.255a2.785 2.785 0 0 0 1.787-2.88v-.041c-.022-1.524-.759-1.975-1.87-1.567",
    transform: "translate(-382.715 -440.672)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M390.889 460.895a2.048 2.048 0 0 0-1.167 1.509l-.014-.993-.838.309.076 5.307.838-.308-.04-2.762a1.735 1.735 0 0 1 1.161-1.917z",
    transform: "translate(-384.675 -440.826)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M393.382 462.153a1.8 1.8 0 0 1 .912-1.655c.52-.191.845.095.9.991zm.9-2.549a3.459 3.459 0 0 0-1.766 3.4v.082c.025 1.669.81 2.414 1.876 2.023a2.572 2.572 0 0 0 1.641-2.334l-.811.3a1.229 1.229 0 0 1-.819 1.116c-.627.231-.983-.214-1.025-1.208l2.661-.977-.005-.356c-.027-1.9-.849-2.376-1.752-2.045",
    transform: "translate(-385.837 -440.383)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "m400.273 460.536-1.666.612.014 1.016 1.666-.612z",
    transform: "translate(-387.78 -440.711)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M402.889 458.662a1.8 1.8 0 0 1 .912-1.655c.523-.193.845.095.9.989zm.9-2.549a3.46 3.46 0 0 0-1.767 3.4v.082c.024 1.67.81 2.414 1.881 2.021a2.576 2.576 0 0 0 1.641-2.334l-.811.3a1.231 1.231 0 0 1-.823 1.118c-.623.229-.979-.215-1.021-1.21l2.657-.975-.005-.356c-.027-1.9-.849-2.376-1.752-2.045",
    transform: "translate(-388.869 -439.27)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M412.44 452.534a2.234 2.234 0 0 0-1.217 1.4c-.189-.594-.569-.748-1.04-.575a2.013 2.013 0 0 0-1.094 1.329l-.012-.812-.839.308.077 5.308.838-.309-.046-3.176a1.512 1.512 0 0 1 .782-1.513c.411-.151.652.1.663.877l.048 3.282.839-.308-.046-3.177a1.511 1.511 0 0 1 .781-1.513c.415-.153.652.1.663.877l.047 3.282.839-.308-.048-3.363c-.021-1.46-.573-1.855-1.236-1.612",
    transform: "translate(-390.852 -438.138)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M419.482 454.883c-.612.225-1.015-.185-1.032-1.376v-.082c-.017-1.174.39-1.9.974-2.118.547-.2.975.223.992 1.4v.082c.016 1.139-.315 1.871-.934 2.1m.142-4.619a2.275 2.275 0 0 0-1.173 1.4l-.012-.853-.839.309.1 7.123.839-.308-.038-2.651a.888.888 0 0 0 1.2.5c.939-.345 1.6-1.624 1.571-3.329v-.082c-.025-1.717-.738-2.441-1.649-2.107",
    transform: "translate(-393.837 -437.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "m424.869 445.116-.839.308.112 7.765.839-.308z",
    transform: "translate(-395.887 -435.794)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M428.408 451.654c-.639.234-1.016-.314-1.032-1.4v-.082c-.016-1.092.354-1.891.981-2.122s1.009.3 1.024 1.4v.07c.015 1.086-.35 1.907-.974 2.136m-.065-4.566a3.487 3.487 0 0 0-1.83 3.425v.082c.023 1.611.83 2.407 1.9 2.014a3.466 3.466 0 0 0 1.826-3.417v-.076c-.023-1.623-.838-2.416-1.9-2.027",
    transform: "translate(-396.679 -436.392)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "m435.872 444.233-.819.3-.842 3.743-1.012-3.062-.911.334 1.507 4.236-.625 2.6.827-.3z",
    transform: "translate(-398.521 -435.512)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M442.678 441.433a2.234 2.234 0 0 0-1.217 1.4c-.189-.594-.569-.748-1.04-.575a2 2 0 0 0-1.09 1.327l-.012-.812-.843.309.077 5.308.842-.31-.046-3.176a1.507 1.507 0 0 1 .778-1.512c.411-.151.652.095.663.877l.048 3.282.839-.308-.046-3.177a1.511 1.511 0 0 1 .781-1.513c.415-.153.652.1.663.877l.047 3.282.839-.308-.048-3.363c-.021-1.46-.573-1.855-1.236-1.612",
    transform: "translate(-400.494 -434.598)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M448.4 441.954a1.8 1.8 0 0 1 .912-1.655c.519-.191.845.095.9.991zm.9-2.549a3.46 3.46 0 0 0-1.767 3.4v.082c.024 1.67.81 2.414 1.876 2.023a2.572 2.572 0 0 0 1.641-2.334l-.811.3a1.23 1.23 0 0 1-.819 1.116c-.627.231-.983-.214-1.025-1.208l2.66-.977v-.356c-.027-1.9-.849-2.376-1.752-2.045",
    transform: "translate(-403.383 -433.942)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M455.763 437a2.024 2.024 0 0 0-1.161 1.383l-.012-.84-.839.308.076 5.308.839-.309-.045-3.129a1.554 1.554 0 0 1 .836-1.582c.5-.183.729.1.74.9l.046 3.229.839-.309-.048-3.339c-.021-1.46-.545-1.889-1.272-1.622",
    transform: "translate(-405.366 -433.182)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "m460.745 433.768-.839.309.017 1.168-.488.178.014.923.487-.179.042 2.9c.015 1 .4 1.432 1.122 1.167a1.686 1.686 0 0 0 .565-.336l-.014-.975a1.083 1.083 0 0 1-.406.249c-.264.1-.422-.057-.429-.523l-.04-2.791.8-.294-.013-.922-.8.293z",
    transform: "translate(-407.178 -432.175)",
    style: {
      fill: "#fff"
    }
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/home-image.7258165828a4be23da31a5dfe056d80c.svg";
export { ForwardRef as ReactComponent };